export interface StaffData {
    stf_id?: number
    stf_name?: string
    stf_mail?: string
    stf_code?: string
    login_str?: string
    stf_access_list?: string[]
    stf_tel?: string
    acle_id?: number
    access_level?: string
    admin_str_id_list?: number[]
    admin_str_name_list?: string[]
    login_pass?: string
    login_pass_confirm?: string
}
export interface ObjectToStaffDataProps {
    stf_id: number | string
    stf_name: string
    stf_mail?: string
    stf_code?: string
    login_str?: string
    stf_access_list?: string
    stf_tel?: string
    acle_id?: string
    acle_id_list?: string
    access_level_list?: string
    access_level?: string
    access_list?: string
    admin_str_id_list?: string
    admin_str_name_list?: string
    admin_store_list?: string
}
export function ObjectToStaffData(obj: ObjectToStaffDataProps): StaffData {
    if (obj.access_list) {
        obj.access_level_list = obj.access_list
    }
    if (obj.admin_store_list) {
        obj.admin_str_name_list = obj.admin_store_list
    }
    if (obj.acle_id_list && !obj.acle_id) {
        obj.acle_id = obj.acle_id_list.split(",").at(0)
    }
    if (obj.access_level_list && !obj.access_level) {
        obj.access_level = obj.access_level_list.split(",").at(0)
    }
    return {
        stf_id: typeof obj.stf_id == "string" ? parseInt(obj.stf_id) : obj.stf_id,
        stf_name: obj.stf_name,
        stf_mail: obj.stf_mail,
        stf_code: obj.stf_code,
        login_str: obj.login_str,
        stf_access_list: obj.stf_access_list ? obj.stf_access_list.split(",") : undefined,
        stf_tel: obj.stf_tel,
        acle_id: typeof obj.acle_id == "string" ? parseInt(obj.acle_id) : obj.acle_id,
        access_level: obj.access_level,
        admin_str_id_list: obj.admin_str_id_list ? obj.admin_str_id_list.split(",").map(value => parseInt(value)) : undefined,
        admin_str_name_list: obj.admin_str_name_list ? obj.admin_str_name_list.split(",") : undefined,
    }
}